// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23bAU","largestCol":"styles_largestCol__3gFrk","smallestCol":"styles_smallestCol__2Bip3"};